import { render, staticRenderFns } from "./CUUser.vue?vue&type=template&id=18b0d01e&scoped=true"
import script from "./CUUser.vue?vue&type=script&lang=js"
export * from "./CUUser.vue?vue&type=script&lang=js"
import style0 from "./CUUser.vue?vue&type=style&index=0&id=18b0d01e&prod&scoped=true&lang=css"
import style1 from "./CUUser.vue?vue&type=style&index=1&id=18b0d01e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0d01e",
  null
  
)

export default component.exports